import { noop } from 'lodash/fp';
import { Component, createElement } from 'react';
import { connect } from 'react-redux';
import { OptimusPlainLink } from '@mews-commander/ui';
import { openModal as openModalAction } from '../../../../../modules/app/actions/common';

interface OwnProps {
    action?: {
        text?: string;
        url?: string;
        icon?: string;
    };
    close?: $TSFixMeFunction;
}

type Props = OwnProps & typeof ModalOpenerAction.defaultProps;

class ModalOpenerAction extends Component<Props> {
    static defaultProps = {
        close: noop,
    };

    handleClick = () => {
        // @ts-expect-error $TSFixMeError: Property 'reloadCurrentModal' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { close, action, openModal } = this.props;

        // @ts-expect-error $TSFixMeError: Object is possibly 'undefined'.
        if (action.disabled) return;

        close();
        openModal(action?.url);

        return false;
    };

    render() {
        // @ts-expect-error $TSFixMeError: Property 'component' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { action, component } = this.props;
        // @ts-expect-error $TSFixMeError: Property 'icon' does not exist on type '{ text?: string | undefined; url?: string | undefined; icon?: string | undefined...
        const { icon, text, url, disabled } = action;

        return (
            <OptimusPlainLink
                underline={false}
                onClick={this.handleClick}
                disabled={disabled}
                {...(disabled ? { as: 'span' } : { href: url })}
            >
                {createElement(component, {
                    title: text,
                    icon,
                    disabled,
                })}
            </OptimusPlainLink>
        );
    }
}

export default connect(undefined, {
    openModal: openModalAction,
})(ModalOpenerAction);
